import r from "./ghl-ui.es793.js";
import a from "./ghl-ui.es794.js";
import p from "./ghl-ui.es795.js";
import s from "./ghl-ui.es796.js";
import i from "./ghl-ui.es797.js";
import m from "./ghl-ui.es798.js";
function t(o) {
  var e = this.__data__ = new r(o);
  this.size = e.size;
}
t.prototype.clear = a;
t.prototype.delete = p;
t.prototype.get = s;
t.prototype.has = i;
t.prototype.set = m;
export {
  t as default
};
